import type TodoFolderStore from './schema/TodoFolderStore';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

export const getStore = createStore<TodoFolderStore>('todoFolderStore', <TodoFolderStore>{
    folders: new ObservableMap(),
    loadState: 'None',
});
